import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';

import { defineMessages } from '@/lib/i18n';
import CompanySdsExpirationForm from '@/views/pages/companySettings/CompanySdsExpirationForm.vue';
import CompanySdsRevisionCopyFieldsForm from '@/views/pages/companySettings/CompanySdsRevisionCopyFieldsForm.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CompanySettingsPage',
  setup(__props) {

const m = defineMessages({
  revisionStatusSettings: '改訂ステータス設定',
  revisionCopySettings: '旧版情報のコピー設定',
});

const tab = ref(0);

return { __sfc: true,m, tab, CompanySdsExpirationForm, CompanySdsRevisionCopyFieldsForm }
}

})